export function getAbsoluteTopOfElement(element) {
  return window.pageYOffset + element.getBoundingClientRect().top
}
